export default function(context: any) {
  return {
    httpEndpoint: process.server
      ? process.env.VUE_APP_GRAPHQL_ENDPOINT_SERVER
      : process.env.VUE_APP_GRAPHQL_ENDPOINT,
    getAuth: () => context.app.$auth.getToken('auth0')
  }
}
